export const REQUEST_EMPLOYEE_DATA = 'REQUEST_EMPLOYEE_DATA';
export const SET_EMPLOYEE_DATA = 'SET_EMPLOYEE_DATA';
export const CREATE_NEW_EMPLOYEE_REQUEST = 'CREATE_NEW_EMPLOYEE_REQUEST';
